export default __webpack_public_path__ + "static/media/453.a34d831a.png";